import React from 'react';
import {
  Box,
  Button,
  Grid,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import Section from '../shared/Section';
import SectionHeading from '../shared/SectionHeading';
import foodfe from './logo.svg';
import cloche from './cloche.png';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { useNavigate } from 'react-router-dom';

const experienceTiles = [
  {
    title: 'Premium Daily Dining',
    description:
      'Smart subscription dining. Freshly prepared meals delivered right at your workplace. Fast, tasty, and waste-free.',
    image: foodfe,
    label: 'Predictive daily service',
  },
  {
    title: 'Zero-Waste Events',
    description:
      'Host events that impress without the mess. Move beyond pizza. Choose from a diverse catering and meeting food menu.',
    image: cloche,
    label: 'Impactful gatherings',
  },
];

export const ExpMenu = () => {
  const navigate = useNavigate();

  return (
    <Section
      id='expmenu'
      background='linear-gradient(180deg, rgba(47, 58, 114, 0.04) 0%, rgba(255, 255, 255, 0.9) 100%)'
    >
      <Stack spacing={6}>
        <SectionHeading
          eyebrow='Experiences'
          title='Flexible solutions for every appetite'
          description="Whether it's daily lunch or meals at company meeting and events, Foodfe handles the logistics so you can focus on the experience."
        />
        <Grid
          container
          rowSpacing={4}
          columnSpacing={{ xs: 0, md: 4 }}
          sx={{
            justifyContent: { xs: 'center', md: 'flex-start' },
            maxWidth: { xs: 420, md: 'none' },
            mx: { xs: 'auto', md: 0 },
          }}
        >
          {experienceTiles.map((tile) => (
            <Grid
              item
              xs={12}
              md={6}
              key={tile.title}
              sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-start' } }}
            >
              <Paper
                elevation={0}
                sx={{
                  width: { xs: 'min(420px, 100%)', md: '100%' },
                  mx: 'auto',
                  height: '100%',
                  p: { xs: 4, md: 5 },
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 4,
                  border: '1px solid',
                  borderColor: 'divider',
                  backgroundColor: '#FFFFFF',
                  transition: 'transform 200ms ease, box-shadow 220ms ease',
                  boxShadow: '0px 14px 24px rgba(31, 36, 51, 0.06)',
                  '&:hover': {
                    transform: 'translateY(-10px)',
                    boxShadow: '0px 28px 50px rgba(31, 36, 51, 0.16)',
                  },
                }}
              >
                <Stack spacing={2} direction='row' alignItems='center'>
                  <Box
                    component='span'
                    sx={{
                      fontSize: '1.2rem',
                      fontWeight: 600,
                      letterSpacing: '0.1em',
                      textTransform: 'uppercase',
                      color: 'secondary.main',
                    }}
                  >
                    {tile.label}
                  </Box>
                </Stack>
                <Typography variant='h3'>{tile.title}</Typography>
                <Typography variant='body1'>{tile.description}</Typography>
                <Box
                  sx={{
                    mt: 'auto',
                    borderRadius: 20,
                    background: 'linear-gradient(135deg, rgba(47,58,114,0.08) 0%, rgba(255,255,255,0.9) 100%)',
                    p: 2.5,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: 160,
                    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.6)',
                  }}
                >
                  <Box
                    component='img'
                    src={tile.image}
                    alt={tile.title}
                    sx={{
                      width: '100%',
                      height: '100%',
                      maxHeight: 140,
                      objectFit: 'contain',
                    }}
                  />
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Section>
  );
};
